module.exports = __webpack_public_path__ + "img/user-circle-icon.svg";